import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {hideProductLegend} from '../../actionCreators';
import {getProduct} from '../../../general/selectors';

import MarkSafe from '../../../general/components/MarkSafe';

const Label = gettext('Close');

const Legend = ({legend, onClick}) => (
    <div className="md-legend">
        <div className="product-legend-wrapper">
            <div className="mobile-only product-legend-close close" onClick={onClick}>
                <i className="close-icon">
                    <span className="sr-only">{Label}</span>
                </i>
            </div>
            <MarkSafe Element="div" className="product-legend-content" value={legend} />
        </div>
    </div>
);

const mapStateToProps = state => {
    const {legend} = getProduct(state);

    return {
        legend,
    };
};

const mapDispatchToProps = dispatch => ({
    onClick: () => dispatch(hideProductLegend),
});

export default connect(mapStateToProps, mapDispatchToProps)(Legend);
